import Vue from 'vue';
import GLightbox from 'glightbox';

Vue.component('image-grid-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            lightbox: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.initLightbox();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initLightbox() {
            this.lightbox = GLightbox({
                selector: '.glightbox',
            });
        },
    },
});
